import TYPES from '@/types';

import Vue from 'vue';

// Domain
import {
  CreateInvestorGoalStateManager,
} from '@/modules/flagship/investor-goal/investor_goal/domain/state/create-investor-goal-state-manager';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class InvestorGoalCreatedSuccessfullyViewModel {
  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.CREATE_INVESTOR_GOAL_STATE_MANAGER)
  readonly create_investor_goal_state_manager!: CreateInvestorGoalStateManager;

  readonly i18n_namespace = 'components.flagship.flagship-goals.create-goal.created-successfully';

  private readonly view!: Vue;

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  public constructor(view: Vue) {
    this.view = view;
  }

  product_name = '';

  investor_goal_state = this.create_investor_goal_state_manager.state;

  button_text = '';

  event_name = '';

  contractProduct = () => {
    this.view.$emit(this.event_name);
  }

  goToDashboardGoals = () => {
    window.location.href = '/goals-dashboard';
  }

  initialize = () => {
    this.product_name = this.investor_goal_state.associated_product;
    if (this.product_name === 'Sowos Pocket') {
      this.event_name = 'contractPocket';
      this.button_text = this.translate('contract_pocket');
    } else {
      this.event_name = 'contractWealth';
      this.button_text = this.translate('contract_wealth');
    }
  }
}
